import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Tabs, Tab, List, ListItem, ListItemText, Divider } from '@mui/material';
import './Program.css';

const day1Program = [
  { time: '9:00 AM', title: 'Breakfast', description: 'Breakfast is served.' },
  { time: '10:00 AM', title: 'Nandi', description: 'The wedding ceremony begins with a ritual.' },
  { time: '1:00 PM', title: 'Lunch', description: 'Lunch is served.' },
  { time: '4:00 PM', title: 'Vara Pooje', description: "The Groom's family is welcomed." },
  { time: '7:00 PM', title: 'Reception', description: 'Photo Session followed by a delicious buffet dinner.' },
];

const day2Program = [
  { time: '7:00 AM', title: 'Wedding Ceremony', description: 'The main wedding Ceremony with a few rituals.' },
  { time: '9:00 AM', title: 'Breakfast', description: 'Breakfast is served.' },
  { time: '12:30 PM', title: 'Lunch', description: 'Lunch will be served.' },
];

const Program = () => {
  const [selectedDay, setSelectedDay] = useState(0);
  const programRef = useRef(null);

  const handleTabChange = (event, newValue) => {
    setSelectedDay(newValue);
  };

  const renderProgramDetails = (programDetails) => (
    <List className="program-list">
      {programDetails.map((event, index) => (
        <React.Fragment key={index}>
          <ListItem className="program-item">
            <ListItemText
              primary={`${event.time} - ${event.title}`}
              secondary={event.description}
              className="program-text"
            />
          </ListItem>
          {index < programDetails.length - 1 && <Divider />} {/* Divider between events */}
        </React.Fragment>
      ))}
    </List>
  );

  // Optional useEffect to scroll to the top of the program section on day switch
  useEffect(() => {
    if (programRef.current) {
      programRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [selectedDay]);

  return (
    <Box ref={programRef} className="program-section">
      <Typography variant="h4" gutterBottom className="program-title">
        Wedding Program
      </Typography>

      {/* Tabs for each day */}
      <Tabs
        value={selectedDay}
        onChange={handleTabChange}
        centered
        className="day-tabs"
      >
        <Tab label="Day 1" />
        <Tab label="Day 2" />
      </Tabs>

      {/* Display program details based on selected day */}
      <Box className="program-content">
        {selectedDay === 0 && renderProgramDetails(day1Program)}
        {selectedDay === 1 && renderProgramDetails(day2Program)}
      </Box>
    </Box>
  );
};

export default Program;
